import React, { Component } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { TutorSettingAction } from "./../../redux/actions";
import { connect } from "react-redux";
import { getSetting } from "./../../apis/tutors";
import PersonalInformation from "./PersonalInformation";
import ChangePasswordSetting from "./ChangePasswordSetting";
import PaymentDetail from "./PaymentDetail";
import TutorSettingIdentification from "./TutorSettingIdentification";
import TutorSettingDoctoralCertificate from "./TutorSettingDoctoralCertificate";
import TutorSettingNotification from "./TutorSettingNotification";
import { InfoModal } from "./../../components/modals/InfoModal";
class TutorMainPageSetting extends Component {
  constructor() {
    super();
    this.state = {
      allTutorInfo: {},
      isModalChangePassword: false,
      isModalPersonalInfo: false,
      isModalPayment: false,
      isModalIdentification: false,
      doctoralCertificateOpenModal: false,
      notificationOpenModal: false,
    };
  }
  componentDidMount = () => {
    let user = JSON.parse(localStorage.getItem("userDetail"));
    let user_id = user.user.userId;
    getSetting({ user_id })
      .then((res) => {
        this.props.TutorSettingStoreData(res.data);
        this.setState({
          allTutorInfo: res.data,
        });
      })
      .catch((err) => console.log(err));
  };
  onClose = () => {
    this.setState({
      doctoralCertificateOpenModal: false,
      notificationOpenModal: false,
    });
  };
  render() {
    const {
      allTutorInfo,
      isModalPersonalInfo,
      isModalChangePassword,
      isModalPayment,
      isModalIdentification,
      doctoralCertificateOpenModal,
      notificationOpenModal,
    } = this.state;
    return (
      <>
        <div className="container">
          <div className="tutor-main-page-setting">
            <div>
              <h1 className="head-h1">Account settings</h1>
              <h3 className="head-h3">
                {`${allTutorInfo?.firstName ? allTutorInfo?.firstName : ""} ${
                  allTutorInfo?.lastName ? allTutorInfo?.lastName : ""
                }`}
                <span className="dot"></span>
                <span onClick={ () => this.props.history.push("/tutor-dashboard/profile") }>Go to profile</span>
              </h3>
            </div>
            <Row>
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 1.png")}
                cardHeadTxt="Personal information"
                cardDescription="Personal details and contact information"
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/personal-information")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 2.png")}
                cardHeadTxt="Log in and security"
                cardDescription="Change or update your password"
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/change-password")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 3.png")}
                cardHeadTxt="Identification"
                cardDescription="Add your id verify your identity"
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/identification")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 4.png")}
                cardHeadTxt="Payment details"
                cardDescription="Add bank account information for payments"
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/payment-details")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 5.png")}
                cardHeadTxt="Background check"
                cardDescription="Upload a copy of your enhanced DBS or PVG certificate "
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/identification")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 6.png")}
                cardHeadTxt="Notifications"
                cardDescription="Set your notification and contact preferences "
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/notifications")
                }
              />
              <SettingCard
                cardImage={require("./../../assets/icons/Icon 7.png")}
                cardHeadTxt="Teaching or doctoral certificates"
                cardDescription="Supporting documents to verify your teaching or doctoral status"
                GoToSpecificSetting={() =>
                  this.props.history.push("/tutor-setting/certificates")
                }
              />
          
            </Row>
            <p className="break">Need to take a break from tutoring?</p>
            <span className="offline">Go offline now</span>
          </div>
        </div>
      </>
    );
  }
}

function SettingCard({
  cardImage,
  cardHeadTxt,
  cardDescription,
  imageCircle,
  GoToSpecificSetting,
}) {
  return (
    <Col
      lg={4}
      md={6}
      sm={12}
      xs={12}
      className="card-setting-col"
    >
      <div className="card-setting-div" onClick={GoToSpecificSetting}>
        {imageCircle ? (
          <span
            style={{
              border: "4px solid #007bb8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "50.2px",
              height: "45.3px",
              borderRadius: "100%",
              marginBottom: "15px",
            }}
          >
            <Image
              src={cardImage}
              className="title-Image"
              style={{
                margin: "0",
                width: "30px",
                height: "29px",
              }}
            />
          </span>
        ) : (
          <Image src={cardImage} className="title-Image" />
        )}
        <span className="flex-start-center">
          <h3>{cardHeadTxt} <i className="fa fa-angle-right"></i></h3>
        </span>
        <p>{cardDescription}</p>
      </div>
    </Col>
  );
}

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

export default connect(null, mapDispatchToprops)(TutorMainPageSetting);
